<template>
  <div id="app">
    <Header />
    <router-view />
    <BackTop />
    <Footer />
  </div>
</template>

<script>
  import { BackTop } from 'iview';
  import Header from '@/components/layout/Header';
  import Footer from '@/components/layout/Footer';
  import { baseOfMeta as metaInfo } from '@/utils/vue-meta';
  //import  "babel-polyfill";
  export default {
    components: { Header, Footer, BackTop },
    metaInfo,
  };
</script>
